<script>

import {mapGetters} from "vuex";
import SelectCustomer from "@/view/content/SelectCustomer";
import {GET_USER} from '@/core/services/ajaxUrl';
import {GET_USER_BY_PHONE} from "../../../core/services/store/user/users.module";
import {extend} from 'vee-validate'
import {CONTRACTS_DISPUTES} from "../../../core/services/store/contract/contracts.module";

extend('unique_person', {
    params: ['rows', 'index'],
    message: 'Nhân sự này đã được chia hoa hồng vui lòng chọn nhân sự khác',
    validate(value, {rows, index}) {
        return !rows.some((row, i) => {
            return String(row.user_id) === String(value) && i !== index
        })
    }
})
export default {
    name: "ModalDisputes.vue",
    props: {
        item: Object,
        index: ''
    },
    components: {
        SelectCustomer
    },
    data() {
        return {
            data: [],
            cache_customer: '',
            users: [],
            loading: false
        }
    },
    mounted() {
        console.log(this.item);
        if (this.item.disputes) {
            _.each(this.item.disputes, (item) => {
                let name = this.item.nguoi_gt_id !== item.user_id ? '' : this.item.sale.name
                this.data.push({
                    user_id: item.user_id > 0 ? String(item.user_id + 100000) : '',
                    percent: item.percent,
                    value: item.value,
                    delete: this.item.nguoi_gt_id !== item.user_id
                })
            })

        } else {
            this.data.push({
                user_id: this.item.nguoi_gt_id > 0 ? String(this.item.nguoi_gt_id + 100000) : '',
                percent: 100,
                value: this.item.amount,
                delete: false
            })
        }

    },
    methods: {
        checkPriceWithTotal() {
            let total = this.data.reduce((total, current) => {
                return Number(total) + Number(current.value)
            }, 0)
            if (Number(total) > this.item.amount) {
                this.$message.error('Tổng số tiền chia hoa hồng không được phép lớn hơn số tiền đóng')
            }
        },
        checkPercentWithTotal(index) {
            let total = this.data.reduce((total, current) => {
                return Number(total) + Number(current.percent)
            }, 0)
            if (Number(total) > 100) {
                this.$message.error('Tổng số phần % chia hoa hồng không được phép lớn hơn 100')
            }
            this.data[index].value = Number(this.item.amount) * this.data[index].percent / 100;

        },
        handleSelect(item) {
            console.log(item);
        },
        async onSubmitTime() {
            this.loading = true
            let users = this.data.map((item) => {
                return {
                    "user_id": Number(item.user_id) - 100000,
                    "percent": item.percent,
                    "value": item.value
                }
            })
            let response = await this.$store.dispatch(CONTRACTS_DISPUTES, {amount_id: this.item.id, users})
            if (response.error === true) {
                this.$toast.error('Lỗi trong quá trình phân chia hoa hồng');
            } else {
                this.$toast.success('Xử lý tranh chấp thành công');
            }
            this.loading = false
        },
        addMoreUser() {
            this.data.push({
                user_id: '',
                percent: 0,
                value: 0,
                delete: true
            })
        },
        removeUser(index) {
            this.data.splice(index, 1)
        },
        selectCustomer: async function (value, cb) {
            if (value) {
                this.is_show = true;
                this.user_id = value;
                let response = await this.$store.dispatch(GET_USER_BY_PHONE, {phone: value})
                let results = response.data.map((res) => {
                    let studentId = res.id + 100000
                    return {
                        value: res.id,
                        label: `${studentId} - ${res.name}`
                    }
                })
                cb(results);
            } else {
                cb(this.data);
            }
        },
    },
    computed: {
        ...mapGetters(["currentUser"]),
        getUserUrl: function () {
            return GET_USER
        },

    },
}
</script>

<template>
    <div class="example mb-10">
        <h5 class="mb-4">Tổng số tiền Khách hàng đã nạp: <b>{{ item.amount | formatPrice }}</b></h5>
        <ValidationObserver ref="form" v-slot="{ handleSubmit, invalid }">
            <form class="form" @submit.prevent="handleSubmit(onSubmitTime)">
                <div v-for="(log, index) in data" class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Người giới thiệu </label>
                            <ValidationProvider v-slot="{ errors, classes }" :rules="{
                                unique_person: {
                                  rows: data,
                                  index: index
                                }
                            }" immediate mode="eager" name="Mã nhân sự" vid="user_id">
                                <el-autocomplete
                                    v-model="log.user_id"
                                    :class="classes"
                                    :fetch-suggestions="selectCustomer"
                                    class="w-100"
                                    placeholder="Nhập mã nhân sự"
                                    value-key="label"
                                    @select="handleSelect"
                                ></el-autocomplete>
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block" data-field="name" data-validator="notEmpty">{{
                                            errors[0]
                                        }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">phần % / tổng tiền </label>
                            <ValidationProvider v-slot="{ errors, classes }" name="Phần %" rules="required|min_value:1"
                                                vid="percent">
                                <input v-model="log.percent" :class="classes" class="form-control"
                                       placeholder="Phần trăm được chia" type="number"
                                       @change="checkPercentWithTotal(index)">
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block" data-field="percent" data-validator="notEmpty">{{
                                            errors[0]
                                        }}
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="">Số tiền</label>
                        <div class=" d-flex align-items-start">
                            <ValidationProvider v-slot="{ errors, classes }" name="Số tiền"
                                                rules="required|min_value:1"
                                                vid="value">
                                <input v-model="log.value" :class="classes"
                                       class="form-control w-100"
                                       placeholder="Số tiền được chia"
                                       type="number"
                                       @change="checkPriceWithTotal">
                                <div class="fv-plugins-message-container">
                                    <div class="fv-help-block" data-field="percent" data-validator="notEmpty">{{
                                            errors[0]
                                        }}
                                    </div>
                                </div>
                            </ValidationProvider>
                            <button v-if="log.delete && currentUser.user.permission.includes(permission.SUA_NGAY)"
                                    class="ml-4 h-4 btn btn-sm btn-outline-danger font-weight-bold mr-2"
                                    type="button" @click="removeUser(index)">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <button v-if="currentUser.user.permission.includes(permission.SUA_NGAY)"
                        class="btn btn-sm btn-outline-success font-weight-bold mr-2"
                        type="button" @click="addMoreUser">
                    <i class="fas fa-plus"></i>Thêm người để chia hoa hồng
                </button>
                <div class="float-right">
                    <el-button :disabled="invalid || loading" :loading="loading" class="mr-2 text-white"
                               icon="el-icon-check "
                               native-type="submit" type="primary">Save
                    </el-button>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>